module.exports = __webpack_public_path__ + "assets/align-middle.59a34078.svg";